import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import {
  getCustomizeControlsActions,
  useCustomizeControlsStore,
} from "../../states/cusomize-controls";
import { handleAutoSaveCustomizeControls } from "../../use-cases/customize-control.use-case";

const CustomizeControlsAutoSaveComponent = () => {
  const { id = "" } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  
  // Check if we're in control set edit mode
  const isControlSetEdit = searchParams.get('isControlSetEdit') === 'true';

  const changesMade = useCustomizeControlsStore().changesMade;

  useEffect(() => {
    // EARLY EXIT: Don't auto-save for control set editing
    if (isControlSetEdit) {
      return;
    }

    if (changesMade > 0) {
      const setIsSavingControls = getCustomizeControlsActions()
        .setIsSavingControls;

      setIsSavingControls("EDITED");

      const timer = setTimeout(() => {
        setIsSavingControls("SAVING");
        handleAutoSaveCustomizeControls(id)
          .then(() => {
            setIsSavingControls("SAVED");
          })
          .catch((err) => console.error(err));
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [changesMade, id, isControlSetEdit]);

  return null;
};

export default CustomizeControlsAutoSaveComponent;
